import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from '@/hooks/useAuth.ts';
import { routes } from './routes.tsx';

export const PrivateRoutes: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { user, permissions } = useAuth();
  const [now] = useState(() => Date.now());

  if (!user || user.exp * 1000 <= now || !permissions) {
    return <Navigate to={routes.login} state={{ from: location.pathname }} />;
  }

  return children;
};
